jQuery(document).ready(function() {
 //..................blog page genral recipe............................//
  var a = jQuery('.genral-recipe li').length;
  if(a > 3){
  jQuery('.genral-recipe').owlCarousel({
    loop:false,
    margin:10,
    nav:true,
    responsive:{
      0:{
        items:1
      },
      600:{
        items:2
      },
      1000:{
        items:3
      }
    }
  });
  }
  else{
    
    jQuery(".genral-recipe").removeClass("owl-carousel");
  }
  
  //..................blog page mediterranean-cuisine............................//
  var a = jQuery('.mediterranean-cuisine li').length;
  if(a > 2){
  jQuery('.mediterranean-cuisine').owlCarousel({
    loop:false,
    margin:10,
    nav:true,
    responsive:{
      0:{
        items:1
      },
      600:{
        items:2
      },
      1000:{
        items:2
      }
    }
  });
  }
  else{
    
    jQuery(".mediterranean-cuisine").removeClass("owl-carousel");
  }
  
  
 //.........jquery..........post ttile...//
   var pageURL = jQuery(location).attr("href");
   if ("url:contains('recipe')") {
   jQuery(".Recipe").append("Recipes");
  }
  
   if ("url:contains('cuisine')") {
   jQuery(".Cuisine").append("Healthy Twists To Mediterranean Cuisine");
  }
  
  
});